export function goTop() {
  // let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
  // let timer = setInterval(() => {
  //   let speed = Math.floor(-scrollTop / 10)
  //   //scrollTop获取元素的滚动条的垂直位置，Math.floor() 向下取整
  //   document.documentElement.scrollTop = document.body.scrollTop = scrollTop + speed
  //   //document.documentElement.scrollTop 获取当前页面的滚动条纵坐标位置
  //   if (scrollTop === 0) {
  //     clearInterval(timer)
  //   }
  // }, 20)
  document.documentElement.scrollTop = 0
}
// 跳转至新闻的详情页
export function goNewsDetails(id){
  this.$router.push({ name: 'newsInfo', query: { detailsID:id }}) 
}
// 跳转至新闻列表页
export function goNewsList(){
  this.$router.push({ name: 'newsInfo' }) 
}
// 跳转至产品服务-特点
export function goCharacteristic(tabsType){
  this.$router.push({ name: 'productService', query: { tabsType, }}) 
}
//跳转至行业应用-智慧应急
export function goIntelligentEmergency(){
  this.$router.push({ name: 'intelligentEmergency' }) 
}
//跳转至行业应用-智慧电力
export function goSmartPower(){
  this.$router.push({ name: 'smartPower' }) 
}
//跳转至行业应用-智慧城市
export function goSmartCity(){
  this.$router.push({ name: 'smartCity' }) 
}
//跳转至行业应用-智慧园区
export function goSmartPark(){
  this.$router.push({ name: 'smartPark' }) 
}
//跳转至行业应用-智慧工厂
export function goSmartFactory(){
  this.$router.push({ name: 'smartFactory' }) 
}


// WEBPACK FOOTER //
// ./src/util/index.js